import React, { useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Dialog,
  DialogContent,
  CircularProgress
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "./api/apiClient";

const InviteeMeetingResponse = () => {
  const { id } = useParams(); // meeting ID from link
  const [meeting, setMeeting] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient
      .get(`/meetingschedulers/invite/${id}`)
      .then((res) => setMeeting(res.data))
      .catch((err) => console.error(err));
  }, [id]);

  const handleOk = async() => {
    if (!selectedOption) {
      alert("Please select an option");
      return;
    }
    setIsProcessing(true);
    try{
      await apiClient.put(`/meetingschedulers/invite/${id}/response`,{selectedDate: selectedOption});
      alert("Response saved");
      navigate("/thankyou"); // or some confirmation page
    }catch(err){
      console.error(err);
      alert("Failed to save response");

    }finally{
      setIsProcessing(false);
    }
/*    apiClient
      .put(`/meetingschedulers/invite/${id}/response`, {
        selectedDate: selectedOption,
      })
      .then(() => {
        alert("Response saved");
        navigate("/thankyou"); // or some confirmation page
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to save response");
      }); */
  };

  if (!meeting) return <div>Loading...</div>;

  return (
    <>
    <Paper
      style={{
        padding: 20,
        maxWidth: 500,
        margin: "auto",
        marginTop: 40,
      }}
    >
      <Typography variant="h6">Respond to Meeting Invitation</Typography>
      <Typography variant="subtitle1">{meeting.title}</Typography>

      <RadioGroup
        value={selectedOption}
        onChange={(e) => setSelectedOption(e.target.value)}
      >
        {meeting.proposedDates.map((date, idx) => (
          <FormControlLabel
            key={idx}
            value={date}
            control={<Radio />}
            label={new Date(date).toLocaleString()}
          />
        ))}
        <FormControlLabel
          value="NONE"
          control={<Radio />}
          label="None of the above"
        />
      </RadioGroup>

      <div style={{ marginTop: 20, textAlign: "right" }}>
        <Button variant="outlined" onClick={() => navigate("/")}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: 10 }}
          onClick={handleOk}
        >
          OK
        </Button>
      </div>
    </Paper>
          {/* 🔹 Modal shown during processing */}
          <Dialog open={isProcessing}>
          <DialogContent
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              p: 4,
            }}
          >
            <CircularProgress />
            <Typography>Processing your response...</Typography>
          </DialogContent>
        </Dialog>
        </>  
  );
};

export default InviteeMeetingResponse;
